import {Component, Input, OnInit} from '@angular/core';
import {ThemeService} from "../../services/theme/theme.service";
import {SettingsService} from "../../services/settings/settings.service";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import * as $ from "jquery";

/**
 * The purpose of this component is to insert stuff into the DOM (usually in the knockout side)
 * based on the key supplied and the current theme and settings. Eventually will be replaced with something better.
 */
@Component({
  selector: 'sb-theme-content',
  templateUrl: './theme-content.component.html',
  styleUrls: ['./theme-content.component.scss']
})
export class ThemeContentComponent implements OnInit {

  @Input()
  key;

  html: string;



  constructor(private settingsService: SettingsService,
              private themeService: ThemeService,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    let html = "";
    switch (this.key) {
      case "settings.environment":
        const label = this.settingsService.get('instanceOverride.instance_header_text', "");

        this.applyHeaderOverrides();

        if (label != null && label != "") {
          html = `<span class="app-header-text">${label}</span>`;
        }
        break;
      default:
        html = this.settingsService.get(this.key, '');
    }

    this.html = this.sanitizer.bypassSecurityTrustHtml(html) as string;
  }

  private applyHeaderOverrides() {
    const headerColourOverride = this.settingsService.get('instanceOverride.header_background_color', '');

    if (headerColourOverride !== '') {
      $(`<style type='text/css'>.instance-header-override{ background-color:${headerColourOverride} !important;}</style>`).appendTo('head');
    }
  }
}
